<script setup lang="ts">
import { modalStateEnum, useModalStore } from '@shared/model';
import { setAuthEntryPoint } from '@shared/lib';

const storeModal = useModalStore();

const openLogin = () => {
  setAuthEntryPoint('loyalty_banner');
  storeModal.open(modalStateEnum.Login);
};
</script>

<template>
<div
  class="loyalty-info"
  data-testid="e2e-open-login-modal"
  @click="openLogin"
>
  <div class="flex gap-4 items-center">
    <UIcon name="i-ep-coin" class="w-8 h-8" />
    <div class="loyalty-info__content">
      <b>Получать бонусы и скидки!</b>
      <p class="loyalty-info__hint">Авторизуйтесь, чтобы копить и использовать баллы</p>
    </div>
  </div>

  <UIcon
    name="i-heroicons-chevron-right-20-solid"
    class="w-8 h-8 transition-all ease-in-out duration-300"
  />
</div>
</template>

<style scoped lang="scss">
.loyalty-info{
  @apply cursor-pointer p-4 flex justify-between items-center gap-1 mt-7;
  // Цвет из настроек внешнего вида. Fallback обязателен: если переменная пустая,
  // background-color становится невалидным и баннер уезжает в прозрачный.
  // Значение фолбэка — прежний bg-yellow-300, чтобы вид не изменился сам по себе.
  background-color: var(--app-loyalty-banner, #FDE047);
  color: var(--app-loyalty-banner-foreground, #000000);
  // Скругление из пресета «Скругления элементов»: баннер стоит в одной колонке
  // с карточками каталога, разная форма соседних блоков сразу заметна
  border-radius: var(--app-radius-card, 24px);
}

// Абзацу цвет задаёт глобальный стиль, поэтому раньше здесь стоял !text-black.
// Перебиваем тем же весом, но цветом, посчитанным по контрасту с заливкой.
.loyalty-info__hint{
  color: var(--app-loyalty-banner-foreground, #000000) !important;
}
</style>